export const CLEAR_REFERRAL_CODE = 'ReferralCodes/CLEAR_REFERRAL_CODE';
export const EMPTY_REFERRAL_CODES = 'ReferralCodes/EMPTY_REFERRAL_CODES';
export const SET_REFERRAL_CODE = 'ReferralCodes/SET_REFERRAL_CODE';
export const SET_REFERRAL_CODES = 'ReferralCodes/SET_REFERRAL_CODES';

export const FETCH_REFERRAL_CODES = 'ReferralCodes/FETCH_REFERRAL_CODES';
export const FETCH_REFERRAL_CODES_SUCCESS = 'ReferralCodes/FETCH_REFERRAL_CODES_SUCCESS';
export const FETCH_REFERRAL_CODES_FAILURE = 'ReferralCodes/FETCH_REFERRAL_CODES_FAILURE';

export const SAVE_REFERRAL_CODE = 'ReferralCodes/SAVE_REFERRAL_CODE';
export const SAVE_REFERRAL_CODE_SUCCESS = 'ReferralCodes/SAVE_REFERRAL_CODE_SUCCESS';
export const SAVE_REFERRAL_CODE_FAILURE = 'ReferralCodes/SAVE_REFERRAL_CODE_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/ReferralCodesPage/store/constants.js